module.exports = __webpack_public_path__ + "img/skull_10.f94fc6f8.png";